module.exports = __webpack_public_path__ + "static/img/img-card-motorcycle.2cf758b.png";